import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { Loader } from 'rsuite'

import Umkd from './umkd'
import { AppStateType } from '../../../bll/store'
import errorHandler from '../../../bll/errorHandler'
import openNotification from '../../_ui/notification'
import {
    getDirectionTraining, clearDirectionTraining,
    getFiles, clearFiles,
    getSpecialization, clearSpecialization,
    getSubjects, clearSubjects, deleteFile, movedFile, uploadUmkd
} from '../../../bll/umkd/umkdOperations'

const UmkdContainer = (props: any) => {
    const navigate = useNavigate()

    const [isVisibleLoader, setIsVisibleLoader] = React.useState(false) // Видимость компоненты Loader
    const [isVisibleLoaderSpecialization, setIsVisibleLoaderSpecialization] = React.useState(false) // Видимость компоненты Loader
    const [isVisibleLoaderSubject, setIsVisibleLoaderSubject] = React.useState(false) // Видимость компоненты Loader
    const [isVisibleLoaderFiles, setIsVisibleLoaderFiles] = React.useState(false) // Видимость компоненты Loader

    const [navFilesActive, setNavFilesActive] = React.useState(0) // Какая кнопка активна в Panel файлы
    const [fileMoveType, setFileMoveType] = React.useState('MO') // Тип файла, куда переместить файл

    const [valueFilterDirectionTraining, setValueFilterDirectionTrainig] = React.useState('') // Фильтр напралений подготовки
    const [valueFilterSpecialization, setValueFilterSpecialization] = React.useState('') // Фильтр специализаций
    const [valueFilterSubject, setValueFilterSubject] = React.useState('') // Фильтр дисциплин

    const [selectedDirectionTrainingID, setSelectedDirectionTrainingID] = React.useState('') // Идентификатор активного направления подготовки
    const [selectedSpecializationID, setSelectedSpecializationID] = React.useState('') // Идентификатор активной специализации
    const [selectedSubjectID, setSelectedSubjectID] = React.useState('') // Идентификатор активной дисциплины

    React.useEffect(() => {
        if (!props.disabledTab) {
            setIsVisibleLoader(true)

            props.getDirectionTraining().then((result: any) => {
                setIsVisibleLoader(false)
                
                switch (result?.code) {
                    case "ERR_QUERY_STRING": { return openNotification("Направления подготовки...", props.msg.err_0017, "error", "bottomRight") }
                    default: errorHandler(result?.code, props.msg); break
                }
            })
        } else {
            openNotification("Доступ запрещен...", props.msg.warn_0001, "warning", "bottomRight")
            navigate('/main')
        }

        return () => {
            props.clearDirectionTraining()
            props.clearSpecialization()
            props.clearSubjects()
            props.clearFiles()
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps



    // Функция по загрузке специализаций
    const loadedSpecializations = (value: string) => {
        setIsVisibleLoaderSpecialization(true)
        setSelectedSpecializationID('') // Очищаем выбранную специализацию

        props.getSpecialization(value).then((result: any) => {
            setIsVisibleLoaderSpecialization(false)

            switch (result?.code) {
                case "ERR_QUERY_STRING": { return openNotification("Специализации...", props.msg.err_0018, "error", "bottomRight") }
                default: errorHandler(result?.code, props.msg); break
            }
        })

        setSelectedDirectionTrainingID(value) // Записываем выбранное направление подготовки
    }

    // Функция по загрузке дисциплин
    const loadedSubjects = (value: string) => {
        setIsVisibleLoaderSubject(true)
        setSelectedSubjectID('') // Очищаем выбранную дисциплину

        props.getSubjects(value).then((result: any) => {
            setIsVisibleLoaderSubject(false)

            switch (result?.code) {
                case "ERR_QUERY_STRING": { return openNotification("Дисциплины...", props.msg.err_0019, "error", "bottomRight") }
                default: errorHandler(result?.code, props.msg); break
            }
        })

        setSelectedSpecializationID(value) // Записываем выбранную специализацию
    }

    // Функция по загрузке файлов
    const loadedFiles = (value: string) => {
        setNavFilesActive(0)
        setIsVisibleLoaderFiles(true)

        props.getFiles(value).then((result: any) => {
            setIsVisibleLoaderFiles(false)

            switch (result?.code) {
                case "ERR_QUERY_STRING": { return openNotification("Файлы...", props.msg.err_0020, "error", "bottomRight") }
                default: errorHandler(result?.code, props.msg); break
            }
        })

        setSelectedSubjectID(value) // Записываем выбранную дисциплину
    }



    // Выбор напрвления подготовки и загрузка специализаций
    const onSelectedDirectionTraining = (value: string) => {
        if (selectedDirectionTrainingID) { // Если направление подготовки выбрано
            if (selectedDirectionTrainingID === value) { // Если предыдущее направление подготовки совпадает с текущем выбором
                props.clearSpecialization() // Очищаем в stor специализации
                props.clearSubjects() // Очищаем в stor дисциплины
                props.clearFiles() // Очищаем в stor файлы

                setSelectedDirectionTrainingID('') // Очищаем выбранное направление подготовки
                setSelectedSpecializationID('') // Очищаем выбранную специализацию
            } else {
                loadedSpecializations(value) // Функция по загрузке специализаций
            }
        } else {
            loadedSpecializations(value) // Функция по загрузке специализаций
        }
    }

    // Выбор специализации и загрузка дисциплин
    const onSelectedSpecialization = (value: string) => {
        if (selectedSpecializationID) { // Если специализация выбрана
            if (selectedSpecializationID === value) { // Если предыдущая специализация совпадает с текущем выбором
                props.clearSubjects() // Очищаем в stor дисциплины
                props.clearFiles() // Очищаем в stor файлы

                setSelectedSpecializationID('') // Очищаем выбранную специализацию
            } else {
                loadedSubjects(value) // Функция по загрузке дисциплин
            }
        } else {
            loadedSubjects(value) // Функция по загрузке дисциплин
        }
    }

    // Выбор дисциплины и загрузка файлов
    const onSelectedSubject = (value: string) => {
        if (selectedSubjectID) { // Если дисциплина выбрана
            if (selectedSubjectID === value) { // Если предыдущая дисциплина совпадает с текущем выбором
                props.clearFiles() // Очищаем в stor файлы

                setSelectedSubjectID('') // Очищаем выбранную дисциплину
            } else {
                loadedFiles(value) // Функция по загрузке файлов
            }
        } else {
            loadedFiles(value) // Функция по загрузке файлов
        }
    }



    // Очистка полей фильтра
    const clearFilterValues = (fieldType: string) => {
        if (fieldType === "directionTraining") { setValueFilterDirectionTrainig('') }
        if (fieldType === "specialization") { setValueFilterSpecialization('') }
        if (fieldType === "subject") { setValueFilterSubject('') }
    }

    // Удаление файла
    const onClickButtonDeleteFile = (filetID: number) => {
        setIsVisibleLoaderFiles(true)

        props.deleteFile(filetID, selectedSubjectID).then((result: any) => {
            setIsVisibleLoaderFiles(false)

            switch (result?.code) {
                case "ERR_QUERY_STRING": { return openNotification("Файлы...", props.msg.err_0021, "error", "bottomRight") }
                default: errorHandler(result?.code, props.msg); break
            }
        })
    }

    // Перемещение файла в другой раздел
    const onClickButtonMovedFile = (filetID: number) => {
        setIsVisibleLoaderFiles(true)

        props.movedFile(filetID, fileMoveType, selectedSubjectID).then((result: any) => {
            setIsVisibleLoaderFiles(false)

            switch (result?.code) {
                case "ERR_QUERY_STRING": { return openNotification("Файлы...", props.msg.err_0021, "error", "bottomRight") }
                default: errorHandler(result?.code, props.msg); break
            }
        })
    }



    // Функция по загрузке файлов на сервер
    const fileUploader = (fileList: any, fileType: string) => {
        // setIsVisibleLoaderFiles(true)

        fileList.forEach((file: any) => {
            props.uploadUmkd(file, selectedSubjectID, fileType, file.name).then((result: any) => {
                // setIsVisibleLoaderFiles(false)

                switch (result?.code) {
                    case "ERR_QUERY_STRING": { return openNotification("Ошибка загрузки файла УМКД...", props.msg.err_0022, "error", "bottomRight") }
                    case "ERR_FILE_NOT_FOUND": { return openNotification("Ошибка загрузки файла УМКД...", props.msg.err_0013, "error", "bottomRight") }
                    case "ERR_FILE_EXTNAME": { return openNotification("Ошибка загрузки файла УМКД...", props.msg.err_0023, "error", "bottomRight") }
                    case "ERR_FILE_SIZE": { return openNotification("Ошибка загрузки файла УМКД...", props.msg.err_0024, "error", "bottomRight") }
                    default: errorHandler(result?.code, props.msg); break
                }
            })
        })
    }


    // Свойства передаваемые к компоненту
    const propsToUmkd = {
        onSelectedDirectionTraining, // Выбор напрвления подготовки и загрузка специализаций
        onSelectedSpecialization, // Выбор специализации и загрузка дисциплин
        onSelectedSubject, // Выбор дисциплины и загрузка файлов

        selectedDirectionTrainingID, // Идентификатор активного направления подготовки
        selectedSpecializationID, // Идентификатор активной специализации
        selectedSubjectID, // Идентификатор активной дисциплины

        valueFilterDirectionTraining, setValueFilterDirectionTrainig, // Фильтр напралений подготовки
        valueFilterSpecialization, setValueFilterSpecialization, // Фильтр специализаций
        valueFilterSubject, setValueFilterSubject, // Фильтр дисциплин

        clearFilterValues, // Очистка полей фильтра

        isVisibleLoaderSpecialization, isVisibleLoaderSubject, isVisibleLoaderFiles, // Видимость загрузчика для компонент

        onClickButtonDeleteFile, // Удаление файла
        onClickButtonMovedFile, // Перемещение файла в другой раздел
        navFilesActive, setNavFilesActive, // Какая кнопка активна в Panel файлы
        fileMoveType, setFileMoveType, // Тип файла, куда переместить файл

        fileUploader, // Функция по загрузке файлов на сервер
    }

    return (
        <>
            {isVisibleLoader
                ? <div style={{ height: "100%", position: "relative" }}><Loader center size="md" content="Загрузка данных..." vertical /> </div>
                : <Umkd {...props} {...propsToUmkd} />
            }
        </>
    )
}

let mapState = (state: AppStateType) => {
    return {
        msg: state.msg,
        directionTrainingList: state.umkd.directionTrainingList,
        specializationList: state.umkd.specializationList,
        subjectsList: state.umkd.subjectsList,
        filesListAll: state.umkd.filesList.filter((val: any) => val.file_type === null),
        filesListRpd: state.umkd.filesList.filter((val: any) => val.file_type === 'RPD'),
        filesListMo: state.umkd.filesList.filter((val: any) => val.file_type === 'MO'),
    }
}

export default compose(connect(mapState, {
    getDirectionTraining, clearDirectionTraining,
    getSpecialization, clearSpecialization,
    getSubjects, clearSubjects,
    getFiles, clearFiles, deleteFile, movedFile, uploadUmkd
}))(UmkdContainer)